import React, { useState } from 'react';
import { useBeats } from '../../../hooks/useBeats';
import { Pill } from '../Pill';
import { StageLayout } from '../StageLayout';
const BEATS = [900, 1600];

/** The clinical reward — control over a variable the clinician can control. */
export function Page6Control() {
  const beat = useBeats(BEATS);
  const [evidenceOpen, setEvidenceOpen] = useState(false);
  return <StageLayout centered copy={<>
          <h2 className="font-headline text-[26px] font-extrabold leading-[1.1] text-white opacity-0-init animate-fade-in-up md:text-[44px]" data-id="element-225" data-mp="wbnov7tphu3l">
            More control over a tracking variable you can actually control.
          </h2>

          <p className={`mt-5 font-body text-base leading-snug text-solventum-primary transition-[opacity,transform] duration-300 ease-out md:text-xl ${beat >= 1 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-226" data-mp="icxsxvimi0gt">
            Closer to the force system you intended.
          </p>

          <div className={`mt-7 transition-[opacity,transform] duration-200 ease-out ${beat >= 2 ? 'translate-y-0 opacity-100' : 'translate-y-2 opacity-0'}`} data-id="element-227" data-mp="21skvruk9pz7v">
            <Pill onClick={() => setEvidenceOpen(open => !open)} aria-expanded={evidenceOpen} data-id="element-228" data-mp="1sq37lal1ywi8">
              See the evidence
            </Pill>

            {evidenceOpen && <p className="mt-3 max-w-[360px] rounded-xl border border-white/12 bg-white/[0.03] px-3 py-2.5 font-body text-[11px] leading-snug text-white/55 animate-rise-in md:text-xs" data-id="element-229" data-mp="1iyp7b0la1so1">
                Supporting data on file. The full evidence summary is available
                from your Solventum representative.
              </p>}
          </div>
        </>} data-id="element-224" data-mp="wc6xtz1dp85h" />;
}